/**
 * Build a 1- or 2-character initials string from a freeform name or email.
 * - "Sam Kowalski"          → "SK"
 * - "sam"                   → "S"
 * - "sam.kowalski@x.com"    → "SK"  (split on . / _ in the local-part)
 * - "" / null / undefined   → "?"
 */
export function deriveInitials(input: string | null | undefined | unknown): string {
  if (typeof input !== 'string') return '?';
  const trimmed = input.trim();
  if (!trimmed) return '?';

  const localPart = trimmed.includes('@') ? trimmed.split('@')[0] : trimmed;

  const tokens = localPart.split(/[\s._-]+/).filter(Boolean);
  if (tokens.length === 0) return '?';
  if (tokens.length === 1) return tokens[0][0]?.toUpperCase() ?? '?';
  return (tokens[0][0] + tokens[tokens.length - 1][0]).toUpperCase();
}
